import { BoxArrowUp } from '@phosphor-icons/react';

export default BoxArrowUp;